// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   TextField,
//   Typography,
//   FormControl,
//   Box,
//   Stack
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CommonButton from '../../commons/Button/Button';
// import { addButtonStyle, clearButtonStyle, activeButtonStyle, inactiveButtonStyle } from '../../commons/Button/ButtonStyles';
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import CategorySelect from '../../commons/Select';
// import CustomTextField from '../../commons/TextField';
// import AllSupportModal from './AllSupportModel';

// function SupportCard(props) {
//   const [open, setOpen] = useState(true);

//    const { state, changeNameValue,handleOpenAddUser, handleOpenClearUser } = props;

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const units = ['Service Request Ticket', 'Problem Ticket','Change Request Ticket','Conclusion Ticket','Incident Ticket','Other Ticket'];

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: "24px", padding:"24px" } }}>
//       <DialogTitle sx={{ fontWeight: '600', p:0, fontSize:"22px" }}>
//         Raise New Ticket
//         <IconButton
//           aria-label="close"
//           onClick={handleClose}
//           sx={{ position: 'absolute', right: 16,borderRadius: '8px',width: 32,height: 32,padding:"8px",  bgcolor: '#E74C3C', color: '#fff', '&:hover': { bgcolor: '#C22918' } }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{p:0}}>
//         <Stack spacing={3}>
//           <Box>
//             <Typography variant="body2" fontWeight={400} sx={{ mb: 1, mt:2 }}>
//                                     Ticket Subject <span style={{ color: "red" }}>*</span>
//                                   </Typography>
           
//             <CustomTextField
//              fullWidth
//               placeholder="Enter ticket subject"
//               size="small"
//               variant="outlined"
//             />
          
//              <Box display="flex" alignItems="flex-start" color="#A1A1A1">
//                             <InfoOutlinedIcon fontSize="small" sx={{ mr: 1 , mt:0.5}} />
//                              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
//                Briefly describe the issue or request.
//                     </Typography>
//             </Box>
//           </Box>

//           <Box>
//               <Typography variant="body2" fontWeight={400} sx={{ mb: 1}}>
//                                     Ticket Description <span style={{ color: "red" }}>*</span>
//                                   </Typography>
           
//              <CustomTextField
//             fullWidth
//               multiline
//               placeholder="Describe the issue in detail"
//               size="small"
//               variant="outlined"
//             />
          
//             <Box display="flex" alignItems="flex-start" color="#A1A1A1">
//                             <InfoOutlinedIcon fontSize="small" sx={{ mr: 1 , mt:0.5}} />
//                              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
//                Explain the issue clearly so our team can assist you faster.
//                     </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <FormControl fullWidth size="small">
//               <Typography variant="body2" fontWeight={400} sx={{ mb: 1}}>
//                                    Ticket Type <span style={{ color: "red" }}>*</span>
//                                   </Typography>
             
//                 <CategorySelect
//          required
//         value={state.notify}
//         onChange={(value) => changeNameValue({ notify: value })}
//         options={units}
//         placeholder="Select a category"
//       />
//             </FormControl>
           
//             <Box display="flex" alignItems="flex-start" color="#A1A1A1">
//                             <InfoOutlinedIcon fontSize="small" sx={{ mr: 1 , mt:0.5}} />
//                              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
//                Choose the type that best fits your ticket.
//                     </Typography>
//             </Box>
//           </Box>
//         </Stack>
//       </DialogContent>

//        <Stack direction="row" spacing={2} pt={1} pb={1} marginTop={'24px'}>
//                   <CommonButton
//                     text="Raise Ticket"
//                     fullWidth
//                     onClick={handleOpenAddUser}
//                     sx={addButtonStyle}
//                   />
      
//                   <CommonButton
//                     text="Cancel"
//                     fullWidth
//                      onClick={handleClose}
//                     sx={{bgcolor: '#E74C3C', color: '#fff', fontSize:"16px", height:"40px", '&:hover': { bgcolor: '#C22918' , boxShadow:"none" } }}
//                   />
//                 </Stack>
//                 <AllSupportModal props={props} />
//     </Dialog>
//   );
// }

// export default SupportCard;






import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  FormControl,
  Box,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonButton from '../../commons/Button/Button';
import { addButtonStyle } from '../../commons/Button/ButtonStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AllSupportModal from './AllSupportModel';
import CustomTextField from '../../commons/mutual/TextField';
import CategorySelect from '../../commons/mutual/Select';

function SupportCard(props) {
  const { state, changeNameValue, handleOpenAddUser, handleCloseAddUser } = props;

  const handleClose = () => {
    handleCloseAddUser(); // Close modal via parent state
  };

  const units = [
    'Service Request Ticket',
    'Problem Ticket',
    'Change Request Ticket',
    'Conclusion Ticket',
    'Incident Ticket',
    'Other Ticket'
  ];

  return (
    <Dialog
      // open={true}
      // onClose={handleClose}
       open={props.open} onClose={props.onClose} 
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: "24px", padding: "24px" } }}
    >
      <DialogTitle sx={{ fontWeight: '600', p: 0, fontSize: "22px" }}>
        Raise New Ticket
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            borderRadius: '8px',
            width: 32,
            height: 32,
            padding: "8px",
            bgcolor: '#E74C3C',
            color: '#fff',
            '&:hover': { bgcolor: '#C22918' }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Stack spacing={3}>
          {/* Subject */}
          <Box>
            <Typography variant="body2" fontWeight={400} sx={{ mb: 1, mt: 2 }}>
              Ticket Subject <span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField fullWidth placeholder="Enter ticket subject" size="small" variant="outlined" />
            <Box display="flex" alignItems="flex-start" color="#A1A1A1">
              <InfoOutlinedIcon fontSize="small" sx={{ mr: 1, mt: 0.5 }} />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                Briefly describe the issue or request.
              </Typography>
            </Box>
          </Box>

          {/* Description */}
          <Box>
            <Typography variant="body2" fontWeight={400} sx={{ mb: 1 }}>
              Ticket Description <span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              fullWidth
              multiline
              placeholder="Describe the issue in detail"
              size="small"
              variant="outlined"
            />
            <Box display="flex" alignItems="flex-start" color="#A1A1A1">
              <InfoOutlinedIcon fontSize="small" sx={{ mr: 1, mt: 0.5 }} />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                Explain the issue clearly so our team can assist you faster.
              </Typography>
            </Box>
          </Box>

          {/* Ticket Type */}
          <Box>
            <FormControl fullWidth size="small">
              <Typography variant="body2" fontWeight={400} sx={{ mb: 1 }}>
                Ticket Type <span style={{ color: "red" }}>*</span>
              </Typography>
              <CategorySelect
                required
                value={state.notify}
                onChange={(value) => changeNameValue({ notify: value })}
                options={units}
                placeholder="Select a category"
              />
            </FormControl>
            <Box display="flex" alignItems="flex-start" color="#A1A1A1">
              <InfoOutlinedIcon fontSize="small" sx={{ mr: 1, mt: 0.5 }} />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                Choose the type that best fits your ticket.
              </Typography>
            </Box>
          </Box>
        </Stack>
      </DialogContent>

      <Stack direction="row" spacing={2} pt={1} pb={1} marginTop={'24px'}>
        <CommonButton
          text="Raise Ticket"
          fullWidth
          onClick={() => changeNameValue({ openAddUser: true })}
          sx={addButtonStyle}
        />
        <CommonButton
          text="Cancel"
          fullWidth
          // onClick={handleClose}
          onClick={props.onClose}
          sx={{
            bgcolor: '#E74C3C',
            color: '#fff',
            fontSize: "16px",
            height: "40px",
            '&:hover': { bgcolor: '#C22918', boxShadow: "none" }
          }}
        />
      </Stack>

      <AllSupportModal props={props} />
    </Dialog>
  );
}

export default SupportCard;
